import { render, staticRenderFns } from "./userPurchaseAgreement.vue?vue&type=template&id=a715eb02&scoped=true"
import script from "./userPurchaseAgreement.vue?vue&type=script&lang=js"
export * from "./userPurchaseAgreement.vue?vue&type=script&lang=js"
import style0 from "./userPurchaseAgreement.vue?vue&type=style&index=0&id=a715eb02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a715eb02",
  null
  
)

export default component.exports